// SPDX-License-Identifier: AGPL-3.0-or-later

const activeDrags = 0;

export function isScrollbarDragActive() {
	return activeDrags > 0;
}
